<template>
  <j-modal :title="title" v-dragModal :width="1000" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '650px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="false">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <!-- <a-col :span="12">
              <a-form-model-item label="创建人">
                <j-select-user-by-dep v-model="model.createBy" />
              </a-form-model-item>
            </a-col> -->
            <a-col :span="12">
              <a-form-model-item :label="$t('工作开始日期')" prop="jobStartTime">
                <a-date-picker v-model="model.jobStartTime" :placeholder="$t('请选择工作开始日期')" valueFormat="YYYY-MM-DD"  @change="onChange" @ok="onOk" style="width: 100%;" :disabled="disableSubmit"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('工作结束日期')" prop="jobEndTime">
                <a-date-picker v-model="model.jobEndTime" :placeholder="$t('请选择工作结束日期')" valueFormat="YYYY-MM-DD"  @change="onChange" @ok="onOk" style="width: 100%;" :disabled="disableSubmit"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('抄送人员')">
                <j-select-user-by-dep v-model="model.sendUser" @change="sendChange" :disabled="disableSubmit" />
              </a-form-model-item>
            </a-col>
            <!-- <a-col :span="12">
              <a-form-model-item label="工作人员" prop="employee">
                <j-select-user-by-dep v-model="model.employee" />
              </a-form-model-item>
            </a-col> -->
            <!-- <a-col :span="12">
              <a-form-model-item label="所属部门" prop="departName">
                <j-select-depart v-model="model.departName" :multi="false"></j-select-depart>
              </a-form-model-item>
            </a-col> -->
            <a-col :span="24">
              <a-form-model-item :label="$t('工作内容')">
                <j-editor  v-model="model.contentInfo" :disabled="disableSubmit"></j-editor>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('附件')">
                <JUpload v-model="fileList" @change="uploadChange" :buttonVisible="false" v-if="disableSubmit"/>
                <JUpload v-model="fileList" @change="uploadChange" v-else/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  // import {
  //   JeecgListMixin
  // } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import JUpload from '@/components/jeecg/JUpload'
  import JEditor from '@/components/jeecg/JEditor'
  import JSelectDepart from '@/components/jeecgbiz/JSelectDepart'
  import JSelectUserByDep from "@/components/jeecgbiz/JSelectUserByDep"
  export default {
    // mixins: [JeecgListMixin],
    name: 'modal',
    components: {
      JUpload,
      JEditor,
      JSelectDepart,
      JSelectUserByDep
    },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          add: "/jeecg-oa/jobLogging/bsJobLogging/add",
          edit: "/jeecg-oa/jobLogging/bsJobLogging/edit",
          queryById: "/jeecg-oa/jobLogging/bsJobLogging/queryById",
        },
        fileList:[]
      }
    },
    computed: {
      validatorRules() {
        return {
          jobStartTime: [{
            required: true,
            message: this.$t('请选择工作开始日期'),
            trigger: 'change'
          }],
          jobEndTime: [{
            required: true,
            message: this.$t('请选择工作结束日期'),
            trigger: 'change'
          }],
          employee: [{
            required: true,
            message: this.$t('请选择工作人员'),
            trigger: 'change'
          }],
          departName: [{
            required: true,
            message: this.$t('请选择所属部门'),
            trigger: 'change'
          }],
        }
      },
    },
    methods: {
      sendChange(ids,names){
        this.$set(this.model,'sendUserName',names);
      },
      uploadChange(file){
        this.$set(this.model,'files',file);
        this.$nextTick(()=>{
          this.$refs.form.validateField('files');
        })
      },
      init(row,type,jobLoggingType){
        this.visible = true;
        this.model = JSON.parse(JSON.stringify(row));
        this.model.jobLoggingType = jobLoggingType;
        if (this.model.files == null) {
          this.fileList = []
        } else {
          this.fileList = [this.model.files];
        }
        if(type == 'edit'){
          this.title = this.$t('编辑');
          this.disableSubmit = false;
        }else if(type == 'detail'){
          this.title = this.$t('详情');
          this.disableSubmit = true;
        }else{
          this.title = this.$t('新增');
          this.disableSubmit = false;
        }
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      },
      handleOk(){
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.close();
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      }
    }
  }
</script>